import { render, staticRenderFns } from "./GlyphInventoryManagementPanel.vue?vue&type=template&id=2f13930a&scoped=true"
import script from "./GlyphInventoryManagementPanel.vue?vue&type=script&lang=js"
export * from "./GlyphInventoryManagementPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13930a",
  null
  
)

export default component.exports